import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface DeleteConfirmationDialogData {
  message: string;
  /** Rendered in bold after `message`, followed by `?`. */
  name?: string;
}

@Component({
  selector: 'app-delete-confirmation-dialog',
  templateUrl: './delete-confirmation-dialog.component.html',
  styleUrls: ['./delete-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DeleteConfirmationDialogComponent {
  protected readonly data: DeleteConfirmationDialogData = inject(NZ_MODAL_DATA);
  private readonly dialogRef = inject(NzModalRef);

  protected close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}

/** Opens the delete confirmation; emits `true` once when the user confirms. */
export function openDeleteConfirmation(
  modalService: NzModalService,
  data: DeleteConfirmationDialogData,
): Observable<true> {
  return modalService.create<DeleteConfirmationDialogComponent, DeleteConfirmationDialogData>({
    nzContent: DeleteConfirmationDialogComponent,
    nzClosable: false,
    nzMaskClosable: false,
    nzClassName: 'delete-confirmation-modal',
    nzWrapClassName: 'delete-confirmation-modal-wrap',
    nzStyle: { width: '450px', height: 'auto' },
    nzBodyStyle: { width: '450px', height: 'auto', overflow: 'hidden', padding: '0px' },
    nzCentered: true,
    nzFooter: null,
    nzData: data,
  }).afterClose.pipe(filter((res): res is true => res === true));
}
